import {
  ADD_SAFETY_WALK_REQUEST,
  DELETE_SAFETY_WALK_REQUEST,
  FETCH_SAFETY_WALKS_REQUEST,
  FETCH_SAFETY_WALKS_RESPONSE,
  LOAD_SAFETY_WALK,
  SET_ACTIVE_SAFETY_WALK,
  UPDATE_SAFETY_WALK_REQUEST
} from '../constants/actionTypes';

export const loadSafetyWalk = payload => ({
  type: LOAD_SAFETY_WALK,
  payload
});

export const fetchSafetyWalksRequest = payload => ({
  type: FETCH_SAFETY_WALKS_REQUEST,
  payload
});

export const fetchSafetyWalksResponse = payload => ({
  type: FETCH_SAFETY_WALKS_RESPONSE,
  payload
});

export const addSafetyWalkRequest = payload => ({
  type: ADD_SAFETY_WALK_REQUEST,
  payload
});

export const setActiveSafetyWalk = payload => ({
  type: SET_ACTIVE_SAFETY_WALK,
  payload
});

export const updateSafetyWalkRequest = payload => ({
  type: UPDATE_SAFETY_WALK_REQUEST,
  payload
});

export const deleteSafetyWalkRequest = payload => ({
  type: DELETE_SAFETY_WALK_REQUEST,
  payload
});
